import React, { useState } from "react";
import { Upload, Button } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { FormattedMessage, useIntl, defineMessages } from "react-intl";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";

import MQTTService from "../../../../services/mqtt";

import importConfigFromFile from "../../../../lib/utils/importConfigFromFile";
import { errorNotification, successNotification } from "../../../../lib/utils/notification";
import { MESSAGE_TYPE } from "../../../../lib/utils/constants";

const translations = defineMessages({
  importSuccess: {
    id: "ImportConfigButton.importSuccess",
    defaultMessage: "Configuration imported successfully",
  },
  invalidFileType: {
    id: "ImportConfigButton.invalidFileType",
    defaultMessage: "You can only upload JSON files!",
  },
  fileTooLarge: {
    id: "ImportConfigButton.fileTooLarge",
    defaultMessage: "File must be smaller than 1MB!",
  },
});

export default function ImportConfigButton({ setVisibleNewNodeChannelForm }) {
  const { formatMessage } = useIntl();
  const [, setImportedConfig] = useState(null);
  const { cwid } = useParams();

  const handleFileUpload = (file) => {
    importConfigFromFile(file, setImportedConfig, errorNotification(formatMessage))
      .then((importedData) => {
        successNotification(formatMessage)(translations.importSuccess);

        const parsedChannelConfig = {
          ...importedData.channelConfig,
          name: `${importedData.channelConfig.name}-imported-${dayjs().unix()}`,
        };

        MQTTService.sendMessageV5({
          topic: `node/${cwid}/in`,
          message: {
            msgType: MESSAGE_TYPE.ADD_NODE_CHANNEL,
            channelConfig: JSON.stringify(parsedChannelConfig),
          },
        });

        setVisibleNewNodeChannelForm(false);
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error("Import config error:", error);
      });

    return false;
  };

  const beforeUpload = (file) => {
    const isJson = file.type === "application/json" || file.name.endsWith(".json");
    if (!isJson) {
      errorNotification(formatMessage)(translations.invalidFileType);

      return false;
    }

    const isLt1M = file.size / 1024 / 1024 < 1;
    if (!isLt1M) {
      errorNotification(formatMessage)(translations.fileTooLarge);

      return false;
    }

    return true;
  };

  return (
    <Upload
      accept=".json,application/json"
      beforeUpload={beforeUpload}
      customRequest={({ file }) => handleFileUpload(file)}
      showUploadList={false}
      maxCount={1}
    >
      <Button type="dashed" icon={<UploadOutlined />}>
        <span>
          <FormattedMessage id="ImportConfigButton.importConfig" defaultMessage="Import Config" />
        </span>
      </Button>
    </Upload>
  );
}
